module.exports = __webpack_public_path__ + "img/1.d764dc9a.png";